(function () {
  'use strict';

  var SVG = {
    back: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
    home: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
    cart: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
    user: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
  };

  var ITEMS = [
    { key:'back', label:'Zurück',    action:'back'              },
    { key:'home', label:'Shop',      href:'/'                   },
    { key:'cart', label:'Warenkorb', href:'/cart', cart:true    },
    { key:'user', label:'Konto',     href:'/account'            },
  ];

  var indicator = null;
  var btns      = [];

  /* ── Active-Tab erkennen ─────────────────────── */
  function activeKey() {
    var p = window.location.pathname;
    if (p === '/cart')           return 'cart';
    if (p.startsWith('/account'))return 'user';
    if (p.includes('/products/'))return 'back';
    if (p === '/' || p === '')   return 'home';
    return 'home';
  }

  /* ── Indicator positionieren ─────────────────── */
  function moveIndicator(btn) {
    if (!indicator || !btn) return;
    var navEl  = btn.closest('.mob-nav');
    var navRect = navEl.getBoundingClientRect();
    var btnRect = btn.getBoundingClientRect();
    var w = btnRect.width * 0.75;
    var l = btnRect.left - navRect.left + (btnRect.width - w) / 2;
    indicator.style.left  = l + 'px';
    indicator.style.width = w + 'px';
  }

  /* ── Bubble-Ripple auf Tap ───────────────────── */
  function spawnRipple(btn, e) {
    var rect   = btn.getBoundingClientRect();
    var ripple = document.createElement('span');
    ripple.className = 'mob-nav__ripple';
    /* Position relativ zum Button */
    var x = (e.clientX || rect.left + rect.width / 2) - rect.left;
    var y = (e.clientY || rect.top  + rect.height / 2) - rect.top;
    ripple.style.left = x + 'px';
    ripple.style.top  = y + 'px';
    btn.appendChild(ripple);
    setTimeout(function () { ripple.remove(); }, 600);
  }

  /* ── Nav bauen ───────────────────────────────── */
  function buildNav() {
    var nav = document.createElement('nav');
    nav.className = 'mob-nav';

    /* Sliding indicator */
    indicator = document.createElement('div');
    indicator.className = 'mob-nav__indicator';
    nav.appendChild(indicator);

    var ak = activeKey();

    ITEMS.forEach(function (item) {
      var btn;
      if (item.href) {
        btn = document.createElement('a');
        btn.href = item.href;
      } else {
        btn = document.createElement('button');
        btn.type = 'button';
      }
      btn.className = 'mob-nav__btn' + (item.key === ak ? ' active' : '');
      btn.dataset.key = item.key;

      var ic  = document.createElement('span'); ic.className = 'mob-nav__icon';  ic.innerHTML = SVG[item.key];
      var lbl = document.createElement('span'); lbl.className = 'mob-nav__label'; lbl.textContent = item.label;
      btn.appendChild(ic); btn.appendChild(lbl);

      if (item.cart) {
        var badge = document.createElement('span');
        badge.className = 'mob-nav__badge';
        badge.id = 'mob-cart-badge';
        btn.appendChild(badge);
      }

      /* Tap handler */
      btn.addEventListener('click', function (e) {
        spawnRipple(btn, e);
        if (navigator.vibrate) navigator.vibrate(6);

        /* Active state */
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        moveIndicator(btn);

        if (item.action === 'back') {
          e.preventDefault();
          history.back();
        }
      }, { passive: false });

      btns.push(btn);
      nav.appendChild(btn);
    });

    document.body.appendChild(nav);

    /* Position indicator after layout */
    requestAnimationFrame(function () {
      var activeBtn = nav.querySelector('.mob-nav__btn.active');
      moveIndicator(activeBtn || btns[1]);
    });

    updateCartCount();
  }

  /* ── Cart Count ──────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.getElementById('mob-cart-badge');
        if (!badge) return;
        var n = cart.item_count || 0;
        if (n > 0) {
          badge.textContent = n > 9 ? '9+' : n;
          badge.classList.add('show');
          /* Highlight cart icon if items present */
          btns.forEach(function(b) {
            if (b.dataset.key === 'cart' && n > 0) {
              var ic = b.querySelector('.mob-nav__icon svg');
              if (ic) ic.style.stroke = '#00C875';
            }
          });
        } else {
          badge.classList.remove('show');
        }
      })
      .catch(function () {});
  }

  /* ── Toast ───────────────────────────────────── */
  var toast = null, toastTimer = null;

  function buildToast() {
    toast = document.createElement('div');
    toast.className = 'mob-toast';
    toast.innerHTML =
      '<span class="mob-toast__icon">🛒</span>' +
      '<span class="mob-toast__text">In den Warenkorb!<small id="mob-toast-name"></small></span>' +
      '<a class="mob-toast__link" href="/cart">Ansehen →</a>';
    document.body.appendChild(toast);
  }

  function showToast(title) {
    if (!toast) return;
    var el = document.getElementById('mob-toast-name');
    if (el && title) el.textContent = title;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3200);
    updateCartCount();
  }

  /* ── Buy Spam Hint ───────────────────────────── */
  var hint = null, hintTimer = null, buyClicks = 0, lastBuy = 0;

  function buildHint() {
    hint = document.createElement('div');
    hint.className = 'mob-buy-hint';
    hint.textContent = 'Wird hinzugefügt...';
    document.body.appendChild(hint);
  }

  function showHint() {
    if (!hint) return;
    hint.classList.add('show');
    clearTimeout(hintTimer);
    hintTimer = setTimeout(function () { hint.classList.remove('show'); }, 1400);
  }

  /* ── Back Button auf Produktseiten ──────────── */
  function injectBackLink() {
    if (!window.location.pathname.includes('/products/')) return;
    var info = document.querySelector('.product__info-wrapper, .product-form');
    if (!info || info.querySelector('.mob-back-btn')) return;
    var btn = document.createElement('a');
    btn.className = 'mob-back-btn';
    btn.href = 'javascript:history.back()';
    btn.innerHTML = '← Zurück';
    info.insertBefore(btn, info.firstChild);
  }

  /* ── Cart Events ─────────────────────────────── */
  function hookCartEvents() {
    document.addEventListener('cart:update', function () {
      var el = document.querySelector('.product__title h1, .product__title');
      showToast(el ? el.textContent.trim().slice(0, 40) : '');
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-form__submit, button[name="add"]');
      if (!btn) return;
      var now = Date.now();
      if (now - lastBuy < 1500) {
        buyClicks++;
        if (buyClicks >= 2) showHint();
      } else {
        buyClicks = 1;
        setTimeout(function () {
          var el = document.querySelector('.product__title h1, .product__title');
          showToast(el ? el.textContent.trim().slice(0, 40) : '');
        }, 1200);
      }
      lastBuy = now;
    }, true);
  }

  /* ── Boot ─────────────────────────────────────── */
  function init() {
    buildNav();
    buildToast();
    buildHint();
    injectBackLink();
    hookCartEvents();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
